export default __webpack_public_path__ + "static/media/virti-light.a5e7a24b.svg";